export default __webpack_public_path__ + "static/media/business3@2x.0702a758.png";